export default "__VITE_ASSET__DKvCAlu0__"